import React from 'react';
import { HiOutlineShieldCheck, HiOutlineClipboardList, HiOutlineLockClosed } from 'react-icons/hi';

export default function InspectionReady() {
  return (
    <div className="relative w-full min-h-screen bg-[#060814] text-white font-sans overflow-hidden select-none flex flex-col justify-between">
      
      {/* Background Kitchen Image Asset Layer */}
      <div 
        className="absolute right-0 top-0 w-full h-full lg:w-1/2 h-1/2 lg:h-full opacity-15 lg:opacity-25 bg-cover bg-center pointer-events-none mix-blend-luminosity z-0"
        style={{ backgroundImage: `url('/assets/image_2a5118ec.png')` }}
      />
      
      {/* High-Resolution Overlay Subtle Gradient depth map */}
      <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-[#060814] via-[#060814]/90 to-transparent pointer-events-none z-0" />

      {/* Main Structural Layout Grid Container optimized for Full HD (FHD) screens */}
      <div className="relative z-10 w-full mx-auto px-6 py-8 sm:px-12 sm:py-16 xl:py-24 gap-8">
        
        {/* Left Interactive Content Area */}
        <div className="flex flex-col justify-center h-full 2xl:max-w-2xl">
          
          {/* Top Content Block */}
          <div>
            <div className="mb-8 sm:mb-12 xl:mb-16 flex flex-col items-start">
              {/* Note: Kept the image logo element exactly here as specified in your layout rewrite */}
              <img src="/assets/logo.png" alt="AAZIRA ONE Logo" className="w-auto h-auto max-w-[180px] xl:max-w-[240px] mb-2" />
              <span className="text-[10px] sm:text-xs xl:text-sm text-gray-400 font-medium tracking-wide mt-1 block">
                Restaurant Operations & Compliance Platform
              </span>
            </div>

            {/* Main Action Title Heading - Upscaled for FHD */}
            <h1 className="text-3xl sm:text-4xl xl:text-5xl font-extrabold tracking-tight mb-4 xl:mb-6 leading-tight xl:leading-[1.15]">
              Operate Smarter.<br />
              Stay <span className="text-[#7C3AED]">Inspection</span> Ready.
            </h1>
            
            {/* Accent Line Design Element */}
            <div className="w-16 xl:w-24 h-1 xl:h-1.5 bg-[#7C3AED] mb-8 xl:mb-10 rounded-full" />
            
            {/* Brand Intro Paragraph info line - Upscaled for FHD */}
            <p className="text-gray-400 text-sm sm:text-base xl:text-lg leading-relaxed xl:leading-heavy max-w-md xl:max-w-xl">
              AAZIRA ONE helps UK restaurants manage food safety, operations, equipment and compliance records in one powerful platform.
            </p>

            {/* Core Responsive Grid Feature List */}
            <div className="mt-10 xl:mt-14 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-1 xl:gap-y-10">
              
              {/* Feature 1 */}
              <div className="flex items-start gap-4 xl:gap-5 group">
                <div className="flex-shrink-0 w-12 h-12 xl:w-14 xl:h-14 rounded-xl border border-purple-500/20 bg-purple-950/10 flex items-center justify-center text-[#7C3AED] transition-all duration-300 group-hover:border-purple-500/40">
                  <HiOutlineShieldCheck className="w-6 h-6 xl:w-7 xl:h-7" />
                </div>
                <div>
                  <h3 className="text-base xl:text-xl font-bold text-gray-100">Designed for UK Restaurants</h3>
                  <p className="text-gray-400 text-xs xl:text-sm mt-1 leading-normal max-w-xs xl:max-w-sm">
                    Built around UK food safety practices and operational requirements.
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="flex items-start gap-4 xl:gap-5 group">
                <div className="flex-shrink-0 w-12 h-12 xl:w-14 xl:h-14 rounded-xl border border-purple-500/20 bg-purple-950/10 flex items-center justify-center text-[#7C3AED] transition-all duration-300 group-hover:border-purple-500/40">
                  <HiOutlineClipboardList className="w-6 h-6 xl:w-7 xl:h-7" />
                </div>
                <div>
                  <h3 className="text-base xl:text-xl font-bold text-gray-100">Stay Inspection Ready</h3>
                  <p className="text-gray-400 text-xs xl:text-sm mt-1 leading-normal max-w-xs xl:max-w-sm">
                    Digital records, checks and logs all in one place.
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="flex items-start gap-4 xl:gap-5 group">
                <div className="flex-shrink-0 w-12 h-12 xl:w-14 xl:h-14 rounded-xl border border-purple-500/20 bg-purple-950/10 flex items-center justify-center text-[#7C3AED] transition-all duration-300 group-hover:border-purple-500/40">
                  <HiOutlineLockClosed className="w-6 h-6 xl:w-7 xl:h-7" />
                </div>
                <div>
                  <h3 className="text-base xl:text-xl font-bold text-gray-100">Secure & Trusted</h3>
                  <p className="text-gray-400 text-xs xl:text-sm mt-1 leading-normal max-w-xs xl:max-w-sm">
                    Your data is protected with industry leading security and UK GDPR standards.
                  </p>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="flex items-start gap-4 xl:gap-5 group">
                <div className="flex-shrink-0 w-12 h-12 xl:w-14 xl:h-14 rounded-xl border border-purple-500/20 bg-purple-950/10 flex items-center justify-center overflow-hidden transition-all duration-300 group-hover:border-purple-500/40">
                  <img src="/assets/uk_flag.png" alt="UK Flag" className="w-8 h-6 object-cover" />
                </div>
                <div>
                  <h3 className="text-base xl:text-xl font-bold text-gray-100">UK Focused. Compliance Driven.</h3>
                  <p className="text-gray-400 text-xs xl:text-sm mt-1 leading-normal max-w-xs xl:max-w-sm">
                    Supporting UK food safety laws and regulations to help you stay prepared.
                  </p>
                </div>
              </div>

            </div>
          </div>

          {/* Bottom Safety Info Notification Section Footer Layer */}
          <div className="mt-12 xl:mt-16 pt-4 flex items-start gap-4 bg-gradient-to-r from-purple-950/10 to-transparent p-4 xl:p-5 rounded-xl border border-purple-900/20 backdrop-blur-sm w-full max-w-md xl:max-w-xl">
            <div className="flex-shrink-0 text-[#7C3AED] mt-0.5">
              <HiOutlineShieldCheck className="w-5 h-5 xl:w-6 xl:h-6" />
            </div>
            <div>
              <h4 className="text-xs xl:text-sm font-bold text-gray-200">Your data is safe with AAZIRA ONE</h4>
              <p className="text-gray-400 text-[11px] xl:text-xs mt-0.5 leading-normal">
                We use industry leading security to protect your business and customer information.{' '}
                <span className="text-[#7C3AED] font-semibold tracking-wide">UK GDPR aligned.</span>
              </p>
            </div>
          </div>

        </div>

        {/* Right Empty Spacing Area placeholder for FHD display layout background optimization */}
        <div className="hidden lg:block w-full h-full pointer-events-none" />

      </div>
    </div>
  );
}
